// src/components/ResponsiveContainer.js

import React from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";

/**
 * ResponsiveContainer wraps content in a Box with responsive padding and width.
 * Use this to ensure consistent responsive layout across views.
 */
const ResponsiveContainer = ({ children }) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isMd = useMediaQuery(theme.breakpoints.between("md", "lg"));

  let maxWidth = 900;
  if (isXs) maxWidth = "100%";
  else if (isSm) maxWidth = 600;
  else if (isMd) maxWidth = 800;

  return (
    <Box
      sx={{
        maxWidth,
        mx: "auto",
        mt: { xs: 2, sm: 3, md: 4 },
        px: { xs: 1, sm: 2, md: 3 },
        width: "100%",
      }}
    >
      {children}
    </Box>
  );
};

export default ResponsiveContainer;
